/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import { Typography2 } from '@coursera/cds-core';
import type { Theme } from '@coursera/cds-core';

import _t from 'i18n!nls/xdp';

type Props = {
  thirdPartyOrgName: string;
  isUpswell?: boolean;
};

const styles = {
  container: (theme: Theme) => css`
    margin-top: ${theme.spacing(16)};
  `,
};

const SponsoredByMessage = ({ thirdPartyOrgName, isUpswell }: Props) => {
  if (isUpswell) {
    return null;
  }

  return (
    <Typography2 component="p" variant="bodySecondary" color="supportText" css={styles.container}>
      <FormattedMessage message={_t('Sponsored by {thirdPartyOrgName}')} thirdPartyOrgName={thirdPartyOrgName} />
    </Typography2>
  );
};

export default SponsoredByMessage;
